<template>
	<div :aria-busy="loading ? 'true' : 'false'">
		<section class="content__custom" v-if="!loading">
			<div class="main-title">
				<h1 class="trash">
					{{ 'trash' | translate | titleCase }}
				</h1>
			</div>
			<div v-if="issues">
				<div v-if="(issues.length > 0)">
					<div class="toolbar">
						<div
							v-if="permaDelete"
							class="toolbar__item toolbar__item--checkbox"
						>
							<input class="input__option checkbox" type="checkbox" v-model="selectAll" :aria-label="$options.filters.translate('select-all')">
						</div>
						<button
							v-if="permaDelete"
							class="toolbar__item"
							@click="deleteIssue"
							:disabled="issueId.length === 0"
							type="button"
							:aria-label="$options.filters.translate('delete')"
						>
							<i class="fas fa-trash" aria-hidden="true"></i>
						</button>
						<div class="toolbar__message" v-show="issueId.length > 0">
							{{ issueId.length }} {{ 'selected-messages' | translate | lowercase }}
						</div>
					</div>
					<table class="table--fixed table-navigation">
						<thead>
							<tr>
								<th
									v-if="permaDelete"
									class="select-cell"
								>
								</th>
								<th class="name-message-cell">{{ 'name' | translate | titleCase }}</th>
								<th class="message-cell">{{ 'message' | translate | titleCase }}</th>
								<th class="date-cell">{{ 'date' | translate | titleCase }}</th>
							</tr>
						</thead>
						<tfoot v-if="issues.length > 10">
							<tr>
								<th
									v-if="permaDelete"
									class="select-cell"
								>
								</th>
								<th>{{ 'name' | translate | titleCase }}</th>
								<th>{{ 'message' | translate | titleCase }}</th>
								<th>{{ 'date' | translate | titleCase }}</th>
							</tr>
						</tfoot>
						<tbody >
							<tr v-for="issue in issues" :key="issue.id" v-bind:class="{ 'tr--bold' : issue.read === 0 }">
								<td
									v-if="permaDelete"
									class="select-cell">
									<label class="label__option">
										<input class="input__option checkbox" type="checkbox" :id="issue.id" name="operator" :value="issue.id" v-model="issueId">
									</label>
								</td>
								<td :title="'name' | translate" class="name-message-cell"><router-link :to="'/mensagens/' + (issue.id)"> {{issue.recipient.name}}</router-link></td>
								<td :title="'message' | translate" class="message-cell"><router-link :to="'/mensagens/' + (issue.id)">{{issue.message}}</router-link></td>
								<td :title="'date' | translate" class="date-cell"><router-link :to="'/mensagens/' + (issue.id)">{{issue.created_at | date }}</router-link></td>
							</tr>
						</tbody>
					</table>

					<pagination
					:classNames="'pagination-arrows pull-right'"
					dispatchToCall="getIgnoredIssues"
					:itemsPerPageProp="session.results"
					:totalItensPagesProps="totalPages"
					:totalItens="totalItems"
					:totalPagesProp="this.totalPages"
					></pagination>
				</div>
				<div v-else>
					<p class="empty-state">
						{{ 'no-message' | translate | capitalize }}
					</p>
				</div>
			</div>
		</section>
	</div>
</template>
<script>
import pagination from '../../components/pagination/pagination.vue';

export default {
	name: 'ignored-message',
	data() {
		return {
			// @TK
			// this is a temporary workout 'cause we don't
			// have the real message delete API endpoint
			// when it becamos available all this validation
			// should be removed
			permaDelete: false,
			loading: false,
			session: {
				page: 1,
				results: 20,
				apiKey: sessionStorage.getItem('apiKey'),
				userId: sessionStorage.getItem('userId'),
			},
			issueId: [],
		};
	},
	components: {
		pagination,
	},
	computed: {
		user() {
			return this.$store.state.user;
		},
		success() {
			return this.$store.state.status;
		},
		issues() {
			return (this.$store.state.issue.issues || []).issues || [];
		},
		selectAll: {
			get() {
				return this.issues ? this.issueId.length === this.issues.length : false;
			},
			set(value) {
				const issueId = [];
				if (value) {
					this.issues.forEach((user) => {
						issueId.push(user.id);
					});
				}
				this.issueId = issueId;
			},
		},
		totalItems() {
			return (this.$store.state.issue.issues || 0).itens_count || 0;
		},
		totalPages: {
			get() {
				return this.totalItems / this.session.results || 0;
			},
			set() {
			},
		},
		itemsOnThisPage() {
			return (this.$store.state.issue.issues.issues || 0).length;
		},
		myPage() {
			return Number(this.$route.query.page);
		},
	},
	methods: {
		paginationData() {
			this.supporters = this.supporters;
		},
		toggleLoading() {
			this.loading = !this.loading;
		},
		getFormData(object) {
			const formData = new FormData();
			Object.keys(object).forEach(key => formData.append(key, object[key]));
			return formData;
		},
		mySession() {
			const mySession = {};
			mySession.page = this.$route.query.page;
			mySession.results = this.session.results;
			mySession.apiKey = sessionStorage.getItem('apiKey');
			mySession.userId = sessionStorage.getItem('userId');
			this.toggleLoading();
			this.$store.dispatch('getIgnoredIssues', mySession)
				.then(() => {
					this.toggleLoading();
				})
				.catch(() => {
					this.toggleLoading();
				});
		},
		deleteIssue() {
			if (this.issueId) {
				const payload = {};
				payload.ids = this.issueId;

				this.$store.dispatch('deleteIssue', this.getFormData(payload))
					.then(() => {
						if (this.myPage === 1) {
							this.mySession();
						// eslint-disable-next-line
						} else if (this.itemsOnThisPage === this.issueId.length && this.myPage >= this.totalPages) {
							this.$router.push({ path: '/mensagens-ignoradas', query: { page: this.$route.query.page - 1 } });
							this.mySession();
						} else {
							this.mySession();
						}
						this.selectAll = false;
						this.issueId = [];
					})
					.catch(() => {
					});
			} else {
				this.erro = true;
			}
		},
	},
	mounted() {
		this.toggleLoading();
		this.$store.dispatch('getIgnoredIssues', this.session)
			.then(() => {
				this.toggleLoading();
			})
			.catch(() => {
				this.toggleLoading();
			});
	},
};
</script>




// WEBPACK FOOTER //
// _source/javascripts/modules/issue/ignoredMessages.vue